import moment from "moment";
import NoData from '../../../assets/images/no_data.png';
import { FC } from "react";
import { LuClipboardList } from "react-icons/lu";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Loader } from "rizzui";

interface DailyNumIndividualsOFCChartProps {   
    data?: any;
}

const DailyNumIndividualsOFCChart: FC<DailyNumIndividualsOFCChartProps> = ({ data }) => {

    // FUNCTIONS

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES FORMATEA LOS DATOS PARA EL GRÁFICO
     * @EN FORMATS THE DATA FOR THE CHART
     */
    // -------------------------------------------------------------------------------------------------------------
    const formatData = (data: any): any => {
        if (!data || data.length === 0) return [];
        
        return data.map((item: any) => ({
            date: item.date,
            individuals: parseInt(item.total_individuals),
            displayDate: new Date(item.date).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit'
            })
        }));
    };
    // -------------------------------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------------------------------
    /**
     * @ES FORMATEA LOS DATOS PARA EL TOOLTIP
     * @EN FORMATS THE DATA FOR THE TOOLTIP
     */
    //--------------------------------------------------------------------------------------------------------------
    const CustomTooltip = ({ active, payload, label }: any) => {
        if (active && payload && payload.length) {
            return (
                <div className="bg-white dark:bg-gray-800 p-3 rounded shadow-lg border border-gray-200 dark:border-gray-600">
                    <p className="text-sm font-semibold text-gray-800 dark:text-white mb-1">
                        Fecha: {moment(payload[0].date).format('DD/MM/YYYY')}
                    </p>
                    <p className="text-sm text-gray-600 dark:text-gray-300">
                        <span className="w-2 h-2 inline-block mr-2 bg-primary rounded-full"></span>
                        Individuos OFC: {payload[0].value}
                    </p>
                </div>
            );
        }
        return null;
    };
    //--------------------------------------------------------------------------------------------------------------

    // Datos formateados
    const chartData = formatData(data);

    // RENDER

    return (
        <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg p-4">
            <div className="flex items-start justify-between mb-4">
                <div className="flex flex-col">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-white">Individuos OFC Diarios</h2>
                    <p className="text-sm text-gray-400 dark:text-gray-300">Evolución diaria del número de individuos observados fuera de censo</p>  
                </div>
                <LuClipboardList className="mt-1 text-primary" />
            </div>

            <div className="flex items-center justify-center mt-4">
                {data ? (
                    chartData.length === 0 ? (
                        <div className="flex items-center justify-center flex-col py-8">
                            <img src={NoData} alt="Logo de Austros" className='max-w-[150px]' />
                            <p className="text-gray-400 dark:text-gray-300">No hay datos disponibles</p>
                        </div>
                    ) : (
                        <div className="w-full h-64">
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
                                    <XAxis 
                                        dataKey="displayDate" 
                                        tick={{ fontSize: 12 }}
                                        className="text-gray-600 dark:text-gray-300"
                                    />
                                    <YAxis 
                                        tick={{ fontSize: 12 }}
                                        className="text-gray-600 dark:text-gray-300"
                                    />
                                    <Tooltip content={<CustomTooltip />} />
                                    <Line 
                                        type="monotone" 
                                        dataKey="individuals" 
                                        stroke="#10b981" 
                                        strokeWidth={2}
                                        dot={{ fill: '#10b981', strokeWidth: 2, r: 4 }}
                                        activeDot={{ r: 6, stroke: '#10b981', strokeWidth: 2 }}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    )
                ) : (
                    <div className="flex items-center justify-center py-8">
                        <Loader color="primary" size="sm" />
                    </div>
                )}
            </div>
        </div>
    );
}

export default DailyNumIndividualsOFCChart;